/* eslint-disable @typescript-eslint/naming-convention */
import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { ColumnModel, IColumnModel } from 'table-editor';
import { ITableColumn, TableColumn, ColumnDataTypes } from 'new-table-editor';

export class LUSource extends StarbaseEntity implements Serializable<LUSource> {

    public source: string;
    public logoPath: string;
    public homePageUrl: string;
    public IsMicrofilm: boolean;

  constructor() {
    super();
  }

    public static LUSourceColumnData(editable: boolean = false): IColumnModel[] {
        return [
            new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
            new ColumnModel('Source Name', 'source', 'Source', editable, 'string', true, true, 100, true),
            new ColumnModel('Logo Path', 'logoPath', 'logoPath', true, 'string', false, false, 9999, true),
            new ColumnModel('URL', 'homePageUrl', 'homePageUrl', true, 'string', false, false, 9999, true),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, true, 50, false),
            new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, true, 20, false)
        ];
    }
    public static CreateLUSourceColumnData(): IColumnModel[] {
        return [
            new ColumnModel('Source Name', 'source', 'Source', true, 'string', false, false, 100, true),
            new ColumnModel('Logo Path', 'logoPath', 'logoPath', true, 'string', false, false, 9999, true),
            new ColumnModel('URL', 'homePageUrl', 'homePageUrl', true, 'string', false, false, 9999, true)
        ];
    }

    public static SourceColumns(editable: boolean = false): ITableColumn[] {
        return [
            new TableColumn('source', 'Source Name', ColumnDataTypes.string, true, editable, true),
            new TableColumn('logoPath', 'Logo Path', ColumnDataTypes.string, false, editable, false),
            new TableColumn('homePageUrl', 'URL', ColumnDataTypes.string, false, editable, false),
            new TableColumn('isMicrofilm', 'Is Microfilm?', ColumnDataTypes.yesno, true, editable, false),
            new TableColumn('createdDateTime', 'Created On', ColumnDataTypes.datetime, false, false, false),
            new TableColumn('createdByUser', 'Created By', ColumnDataTypes.string, false, false, false)
        ];
    }

    deserialize(input) {
        return Object.assign(new LUSource(), input);
    }

}
